import { themedUseStyletron } from '../../../theme/customTheme'
import { IEHeat } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import {  StatefulOperationModeSelect } from '../Aggregate';
import { AggregateOnOffText } from '../Aggregate';
import { Icon } from "./Icon";
import { SmallPanel } from './SmallPanel';

export function OverviewPanel(props: IEHeat) {
    const [, theme] = themedUseStyletron();

    return (
        <OverviewPanelWrapper {...props} icon={<Icon color={theme.colors.backgroundPrimary} width='100%' />}>
            <SmallPanel {...props}></SmallPanel>
            <AggregateOnOffText {...props}></AggregateOnOffText>
            <StatefulOperationModeSelect isCompact {...props}></StatefulOperationModeSelect>
        </OverviewPanelWrapper >
    );
}

